export const ICRC21_CALL_CONSENT_MESSAGE = 'icrc21_call_consent_message';
export const ICRC25_REQUEST_PERMISSIONS = 'icrc25_request_permissions';
export const ICRC25_PERMISSIONS = 'icrc25_permissions';
export const ICRC25_SUPPORTED_STANDARDS = 'icrc25_supported_standards';
export const ICRC27_ACCOUNTS = 'icrc27_accounts';
export const ICRC29_STATUS = 'icrc29_status';
export const ICRC49_CALL_CANISTER = 'icrc49_call_canister';

export const ICRC25_PERMISSION_GRANTED = 'granted';
export const ICRC25_PERMISSION_DENIED = 'denied';
export const ICRC25_PERMISSION_ASK_ON_USE = 'ask_on_use';

export const ICRC21 = 'ICRC-21';
export const ICRC25 = 'ICRC-25';
export const ICRC27 = 'ICRC-27';
export const ICRC29 = 'ICRC-29';
export const ICRC49 = 'ICRC-49';
